const cities = {
  pune: {
    slug: "pune",
    name: "Pune",
    state: "Maharashtra",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Pune | UrbanHomey",

    description:
      "Find compatible flatmates, roommates, shared rooms and rooms for rent in Pune with UrbanHomey. Explore popular areas including Baner, Wakad, Hinjawadi, Kothrud, Viman Nagar and Kharadi.",

    keywords:
      "flatmates in Pune, roommates in Pune, find flatmate Pune, find roommate Pune, rooms for rent in Pune, shared rooms in Pune, shared accommodation Pune, roommate finder Pune, flatmate finder Pune, verified flatmates Pune, student rooms Pune, rooms for working professionals Pune, PG alternatives Pune, co living Pune, UrbanHomey Pune",

    heading: "Find Flatmates, Roommates & Rooms in Pune",

    shortDescription:
      "Discover compatible flatmates, roommates and shared accommodation across Pune based on location, budget, lifestyle and living preferences.",

    areas: [
  "Akurdi",
  "Alandi",
  "Ambegaon Budruk",
  "Anand Nagar",
  "Aundh",
  "Balewadi",
  "Baner",
  "Baner Pashan Link Road",
  "Bavdhan",
  "Bhosari",
  "Bhugaon",
  "Bhukum",
  "Bibwewadi",
  "Boat Club Road",
  "Bopodi",
  "Camp",
  "Chakan",
  "Charholi Budruk",
  "Chikhali",
  "Chinchwad",
  "Dange Chowk",
  "Dapodi",
  "Deccan Gymkhana",
  "Dhanori",
  "Dhayari",
  "Erandwane",
  "Fatima Nagar",
  "Fursungi",
  "Ganeshkhind",
  "Ghorpadi",
  "Hadapsar",
  "Handewadi",
  "Hinjawadi",
  "Kalas",
  "Kalewadi",
  "Kalyani Nagar",
  "Karve Nagar",
  "Kasba Peth",
  "Kasarwadi",
  "Katraj",
  "Keshav Nagar",
  "Khadki",
  "Kharadi",
  "Kondhwa",
  "Koregaon Park",
  "Kothrud",
  "Lohegaon",
  "Magarpatta",
  "Manjari",
  "Market Yard",
  "Model Colony",
  "Mohammed Wadi",
  "Moshi",
  "Mundhwa",
  "Nana Peth",
  "Narhe",
  "NIBM Road",
  "Nigdi",
  "Pashan",
  "Pimple Gurav",
  "Pimple Nilakh",
  "Pimple Saudagar",
  "Pimpri",
  "Pimpri-Chinchwad",
  "Pirangut",
  "Prabhat Road",
  "Punawale",
  "Rahatani",
  "Ravet",
  "Sadashiv Peth",
  "Salisbury Park",
  "Sangvi",
  "Shaniwar Peth",
  "Shivajinagar",
  "Sinhagad Road",
  "Somwar Peth",
  "Sus",
  "Swargate",
  "Talawade",
  "Talegaon Dabhade",
  "Tathawade",
  "Thergaon",
  "Undri",
  "Vadgaon Budruk",
  "Vadgaon Sheri",
  "Viman Nagar",
  "Vishrantwadi",
  "Wadgaon Sheri",
  "Wagholi",
  "Wakad",
  "Wanowrie",
  "Warje",
  "Yerawada"
],
  },

  bangalore: {
    slug: "bangalore",
    name: "Bangalore",
    state: "Karnataka",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Bangalore | UrbanHomey",

    description:
      "Find compatible flatmates, roommates, shared rooms and rooms for rent in Bangalore. Explore accommodation in Koramangala, Whitefield, HSR Layout, Indiranagar, Electronic City and Marathahalli.",

    keywords:
      "flatmates in Bangalore, roommates in Bangalore, find flatmate Bangalore, roommate finder Bangalore, flatmate finder Bangalore, rooms for rent Bangalore, shared rooms Bangalore, shared accommodation Bangalore, verified flatmates Bangalore, student rooms Bangalore, rooms for working professionals Bangalore, co living Bangalore, UrbanHomey Bangalore",

    heading: "Find Flatmates, Roommates & Rooms in Bangalore",

    shortDescription:
      "Find compatible people and shared accommodation across Bangalore's major technology, education and residential hubs.",

    areas: [
      "Koramangala",
      "Whitefield",
      "HSR Layout",
      "Indiranagar",
      "Electronic City",
      "Marathahalli",
      "Bellandur",
      "BTM Layout",
      "Sarjapur Road",
      "Hebbal",
    ],
  },

  hyderabad: {
    slug: "hyderabad",
    name: "Hyderabad",
    state: "Telangana",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Hyderabad | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Hyderabad. Discover shared accommodation around Gachibowli, HITEC City, Madhapur, Kondapur, Kukatpally and Manikonda.",

    keywords:
      "flatmates in Hyderabad, roommates in Hyderabad, find flatmate Hyderabad, roommate finder Hyderabad, rooms for rent Hyderabad, shared rooms Hyderabad, shared accommodation Hyderabad, verified flatmates Hyderabad, student accommodation Hyderabad, working professional rooms Hyderabad, co living Hyderabad, UrbanHomey Hyderabad",

    heading: "Find Flatmates, Roommates & Rooms in Hyderabad",

    shortDescription:
      "Explore flatmates, roommates and shared accommodation across Hyderabad based on your preferred location, budget and lifestyle.",

    areas: [
      "Gachibowli",
      "HITEC City",
      "Madhapur",
      "Kondapur",
      "Kukatpally",
      "Manikonda",
      "Banjara Hills",
      "Jubilee Hills",
      "Miyapur",
      "Begumpet",
    ],
  },

  mumbai: {
    slug: "mumbai",
    name: "Mumbai",
    state: "Maharashtra",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Mumbai | UrbanHomey",

    description:
      "Find compatible flatmates, roommates, shared rooms and rooms for rent in Mumbai. Explore shared accommodation across Andheri, Powai, Bandra, Goregaon, Malad, Navi Mumbai and Thane.",

    keywords:
      "flatmates in Mumbai, roommates in Mumbai, find flatmate Mumbai, roommate finder Mumbai, rooms for rent Mumbai, shared rooms Mumbai, shared flats Mumbai, shared accommodation Mumbai, verified flatmates Mumbai, student rooms Mumbai, working professional rooms Mumbai, co living Mumbai, UrbanHomey Mumbai",

    heading: "Find Flatmates, Roommates & Rooms in Mumbai",

    shortDescription:
      "Connect with compatible flatmates and explore shared accommodation across Mumbai's major residential, business and education hubs.",

    areas: [
  "Aarey Colony",
  "Agripada",
  "Altamount Road",
  "Amboli",
  "Andheri",
  "Andheri East",
  "Andheri West",
  "Antop Hill",
  "Bandra",
  "Bandra East",
  "Bandra West",
  "Bandra Kurla Complex",
  "Bangur Nagar",
  "Bhandup",
  "Bhandup East",
  "Bhandup West",
  "Bhayandar",
  "Bhayandar East",
  "Bhayandar West",
  "Borivali",
  "Borivali East",
  "Borivali West",
  "Breach Candy",
  "Byculla",
  "Carter Road",
  "Chakala",
  "Chandivali",
  "Charni Road",
  "Chembur",
  "Chinchpokli",
  "Churchgate",
  "Colaba",
  "Cuffe Parade",
  "Dadar",
  "Dadar East",
  "Dadar West",
  "Dahisar",
  "Dahisar East",
  "Dahisar West",
  "Deonar",
  "Dharavi",
  "Dindoshi",
  "Dockyard Road",
  "Fort",
  "Ghatkopar",
  "Ghatkopar East",
  "Ghatkopar West",
  "Girgaon",
  "Goregaon",
  "Goregaon East",
  "Goregaon West",
  "Govandi",
  "Grant Road",
  "Jogeshwari",
  "Jogeshwari East",
  "Jogeshwari West",
  "Juhu",
  "Kalbadevi",
  "Kalina",
  "Kandivali",
  "Kandivali East",
  "Kandivali West",
  "Kanjurmarg",
  "Kanjurmarg East",
  "Kanjurmarg West",
  "Khar",
  "Khar East",
  "Khar West",
  "Khar Road",
  "Kurla",
  "Kurla East",
  "Kurla West",
  "Lokhandwala",
  "Lower Parel",
  "Mahalakshmi",
  "Mahim",
  "Malabar Hill",
  "Malad",
  "Malad East",
  "Malad West",
  "Malvani",
  "Marine Drive",
  "Marine Lines",
  "Marol",
  "Matunga",
  "Matunga East",
  "Matunga West",
  "Mazgaon",
  "Mira Road",
  "Mulund",
  "Mulund East",
  "Mulund West",
  "Mumbai Central",
  "Nahur",
  "Nariman Point",
  "Oshiwara",
  "Pali Hill",
  "Pant Nagar",
  "Parel",
  "Powai",
  "Prabhadevi",
  "Santacruz",
  "Santacruz East",
  "Santacruz West",
  "Saki Naka",
  "Sewri",
  "Sion",
  "Tardeo",
  "Tilak Nagar",
  "Versova",
  "Vikhroli",
  "Vikhroli East",
  "Vikhroli West",
  "Vile Parle",
  "Vile Parle East",
  "Vile Parle West",
  "Wadala",
  "Wadala East",
  "Wadala West",
  "Worli"
],
  },

  delhi: {
    slug: "delhi",
    name: "Delhi",
    state: "Delhi",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Delhi | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Delhi. Explore shared accommodation around Saket, Hauz Khas, Dwarka, Rohini, Lajpat Nagar and Connaught Place.",

    keywords:
      "flatmates in Delhi, roommates in Delhi, find flatmate Delhi, roommate finder Delhi, rooms for rent Delhi, shared rooms Delhi, shared accommodation Delhi, verified flatmates Delhi, student rooms Delhi, rooms for working professionals Delhi, co living Delhi, UrbanHomey Delhi",

    heading: "Find Flatmates, Roommates & Rooms in Delhi",

    shortDescription:
      "Discover compatible flatmates, roommates and shared accommodation across Delhi based on budget, location and lifestyle preferences.",

    areas: [
      "Saket",
      "Hauz Khas",
      "Dwarka",
      "Rohini",
      "Lajpat Nagar",
      "Connaught Place",
      "Karol Bagh",
      "Vasant Kunj",
      "Greater Kailash",
      "Mayur Vihar",
    ],
  },

  chennai: {
    slug: "chennai",
    name: "Chennai",
    state: "Tamil Nadu",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Chennai | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Chennai. Explore shared accommodation in Anna Nagar, OMR, Velachery, Adyar, T Nagar and Sholinganallur.",

    keywords:
      "flatmates in Chennai, roommates in Chennai, find flatmate Chennai, roommate finder Chennai, rooms for rent Chennai, shared rooms Chennai, shared accommodation Chennai, verified flatmates Chennai, student rooms Chennai, working professional rooms Chennai, co living Chennai, UrbanHomey Chennai",

    heading: "Find Flatmates, Roommates & Rooms in Chennai",

    shortDescription:
      "Find compatible people and shared accommodation across Chennai's major technology, education and residential areas.",

    areas: [
      "Anna Nagar",
      "OMR",
      "Velachery",
      "Adyar",
      "T Nagar",
      "Sholinganallur",
      "Guindy",
      "Porur",
      "Thoraipakkam",
      "Nungambakkam",
    ],
  },

  kolkata: {
    slug: "kolkata",
    name: "Kolkata",
    state: "West Bengal",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Kolkata | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Kolkata. Explore shared accommodation around Salt Lake, New Town, Park Street, Rajarhat, Ballygunge and Jadavpur.",

    keywords:
      "flatmates in Kolkata, roommates in Kolkata, find flatmate Kolkata, roommate finder Kolkata, rooms for rent Kolkata, shared rooms Kolkata, shared accommodation Kolkata, verified flatmates Kolkata, student rooms Kolkata, working professional rooms Kolkata, co living Kolkata, UrbanHomey Kolkata",

    heading: "Find Flatmates, Roommates & Rooms in Kolkata",

    shortDescription:
      "Discover compatible flatmates, roommates and shared living options across Kolkata's popular residential, education and business districts.",

    areas: [
      "Salt Lake",
      "New Town",
      "Park Street",
      "Rajarhat",
      "Ballygunge",
      "Jadavpur",
      "Dum Dum",
      "Garia",
      "Behala",
      "Kasba",
    ],
  },

  ahmedabad: {
    slug: "ahmedabad",
    name: "Ahmedabad",
    state: "Gujarat",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Ahmedabad | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Ahmedabad. Explore shared accommodation around Satellite, Navrangpura, SG Highway, Bopal, Prahlad Nagar and Thaltej.",

    keywords:
      "flatmates in Ahmedabad, roommates in Ahmedabad, find flatmate Ahmedabad, roommate finder Ahmedabad, rooms for rent Ahmedabad, shared rooms Ahmedabad, shared accommodation Ahmedabad, verified flatmates Ahmedabad, student rooms Ahmedabad, working professional rooms Ahmedabad, co living Ahmedabad, UrbanHomey Ahmedabad",

    heading: "Find Flatmates, Roommates & Rooms in Ahmedabad",

    shortDescription:
      "Connect with compatible flatmates and explore affordable shared accommodation across Ahmedabad's major residential and commercial areas.",

    areas: [
      "Satellite",
      "Navrangpura",
      "SG Highway",
      "Bopal",
      "Prahlad Nagar",
      "Thaltej",
      "Chandkheda",
      "Vastrapur",
      "Gota",
      "South Bopal",
    ],
  },

  jaipur: {
    slug: "jaipur",
    name: "Jaipur",
    state: "Rajasthan",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Jaipur | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Jaipur. Explore shared accommodation in Civil Lines, Malviya Nagar, Mansarovar, Vaishali Nagar and Jagatpura.",

    keywords:
      "flatmates in Jaipur, roommates in Jaipur, find flatmate Jaipur, roommate finder Jaipur, rooms for rent Jaipur, shared rooms Jaipur, shared accommodation Jaipur, verified flatmates Jaipur, student rooms Jaipur, working professional rooms Jaipur, co living Jaipur, UrbanHomey Jaipur",

    heading: "Find Flatmates, Roommates & Rooms in Jaipur",

    shortDescription:
      "Discover compatible flatmates, roommates and shared accommodation across Jaipur's popular education, employment and residential areas.",

    areas: [
      "Civil Lines",
      "Malviya Nagar",
      "Mansarovar",
      "Vaishali Nagar",
      "Jagatpura",
      "C Scheme",
      "Raja Park",
      "Tonk Road",
      "Ajmer Road",
      "Pratap Nagar",
    ],
  },

  lucknow: {
    slug: "lucknow",
    name: "Lucknow",
    state: "Uttar Pradesh",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Lucknow | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Lucknow. Explore shared accommodation in Gomti Nagar, Hazratganj, Aliganj, Indira Nagar and Vibhuti Khand.",

    keywords:
      "flatmates in Lucknow, roommates in Lucknow, find flatmate Lucknow, roommate finder Lucknow, rooms for rent Lucknow, shared rooms Lucknow, shared accommodation Lucknow, verified flatmates Lucknow, student rooms Lucknow, working professional rooms Lucknow, co living Lucknow, UrbanHomey Lucknow",

    heading: "Find Flatmates, Roommates & Rooms in Lucknow",

    shortDescription:
      "Find compatible people and shared accommodation across Lucknow based on your location, budget, lifestyle and living preferences.",

    areas: [
      "Gomti Nagar",
      "Hazratganj",
      "Aliganj",
      "Indira Nagar",
      "Vibhuti Khand",
      "Alambagh",
      "Mahanagar",
      "Jankipuram",
      "Chinhat",
      "Aminabad",
    ],
  },

  kochi: {
    slug: "kochi",
    name: "Kochi",
    state: "Kerala",

    title:
      "Find Flatmates, Roommates & Rooms for Rent in Kochi | UrbanHomey",

    description:
      "Find compatible flatmates, roommates and rooms for rent in Kochi. Explore shared accommodation around Kakkanad, Edappally, Kaloor, Vyttila, Palarivattom and MG Road.",

    keywords:
      "flatmates in Kochi, roommates in Kochi, find flatmate Kochi, roommate finder Kochi, rooms for rent Kochi, shared rooms Kochi, shared accommodation Kochi, verified flatmates Kochi, student rooms Kochi, working professional rooms Kochi, co living Kochi, UrbanHomey Kochi",

    heading: "Find Flatmates, Roommates & Rooms in Kochi",

    shortDescription:
      "Discover compatible flatmates, roommates and shared accommodation across Kochi's major technology, business and residential areas.",

    areas: [
      "Kakkanad",
      "Edappally",
      "Kaloor",
      "Vyttila",
      "Palarivattom",
      "MG Road",
      "Panampilly Nagar",
      "Fort Kochi",
      "Thrippunithura",
      "Marine Drive",
    ],
  },
};

/*
|--------------------------------------------------------------------------
| Reusable City Collections
|--------------------------------------------------------------------------
*/

export const cityList = Object.values(cities);

export const citySlugs = Object.keys(cities);

/*
|--------------------------------------------------------------------------
| Top Cities
|
| Use this in Downloadpage.jsx, Header, Footer or Homepage.
|--------------------------------------------------------------------------
*/

export const topCities = [
  cities.pune,
  cities.bangalore,
  cities.hyderabad,
];

/*
|--------------------------------------------------------------------------
| Footer Cities
|--------------------------------------------------------------------------
*/

export const footerCities = [
  cities.pune,
  cities.bangalore,
  cities.hyderabad,
  cities.mumbai,
  cities.delhi,
  cities.chennai,
  cities.kolkata,
  cities.ahmedabad,
  cities.jaipur,
  cities.lucknow,
  cities.kochi,
];

/*
|--------------------------------------------------------------------------
| Sitemap City URLs
|--------------------------------------------------------------------------
*/

export const citySitemapPaths = cityList.map(
  (city) => `/city/${city.slug}`
);

/*
|--------------------------------------------------------------------------
| Helper Function
|--------------------------------------------------------------------------
*/

export const getCityBySlug = (slug) => {
  if (!slug) return null;

  return cities[slug.toLowerCase()] || null;
};

/* =========================================================
   AUTOMATIC LOCATION PAGE GENERATOR

   Converts areas such as:

   Wakad
   Ravet
   Hinjawadi
   Andheri West
   Powai

   Into:

   /city/wakad
   /city/ravet
   /city/hinjawadi
   /city/andheri-west
   /city/powai
========================================================= */


/* =========================================================
   SLUG GENERATOR
========================================================= */

export function createCitySlug(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}


/* =========================================================
   CREATE LOCATION OBJECT
========================================================= */

function createLocationEntry({
  name,
  parentCity,
  state,
}) {
  const slug = createCitySlug(name);

  return {
    slug,

    name,

    state,

    /*
     * Used internally so we know which
     * main city this location belongs to.
     */

    parentCity,


    /* =========================
       SEO
    ========================= */

    title:
      `Find Flatmates, Roommates & Rooms for Rent in ${name} | UrbanHomey`,

    description:
      `Find compatible flatmates, roommates, shared rooms and rooms for rent in ${name}. Explore shared accommodation and connect with compatible people based on budget, lifestyle and living preferences with UrbanHomey.`,

    keywords:
      `flatmates in ${name}, roommates in ${name}, find flatmate ${name}, find roommate ${name}, rooms for rent in ${name}, shared rooms in ${name}, shared accommodation ${name}, roommate finder ${name}, flatmate finder ${name}, verified flatmates ${name}, student rooms ${name}, rooms for working professionals ${name}, co living ${name}, UrbanHomey ${name}`,

    heading:
      `Find Flatmates, Roommates & Rooms in ${name}`,

    shortDescription:
      `Discover compatible flatmates, roommates, rooms for rent and shared accommodation in ${name} based on location, budget, lifestyle and living preferences.`,


    /*
     * Generated locations currently
     * don't contain child locations.
     */

    areas: [],


    /*
     * Helpful for CityPage,
     * sitemap and filtering.
     */

    isGeneratedLocation: true,
  };
}


/* =========================================================
   MAIN CITIES WHOSE AREAS SHOULD BECOME
   TOP-LEVEL SEO LOCATION PAGES
========================================================= */

const LOCATION_GENERATION_CONFIG = [
  {
    citySlug: "pune",
  },

  {
    citySlug: "mumbai",
  },
];


/* =========================================================
   GENERATE LOCATION ENTRIES
========================================================= */

LOCATION_GENERATION_CONFIG.forEach(
  ({ citySlug }) => {

    const parentCity = cities[citySlug];


    /*
     * Safety check.
     */

    if (!parentCity) {
      console.warn(
        `[cities.js] Cannot generate locations. City "${citySlug}" does not exist.`
      );

      return;
    }


    /*
     * Safety check for areas.
     */

    if (!Array.isArray(parentCity.areas)) {
      return;
    }


    parentCity.areas.forEach((areaName) => {

      const location =
        createLocationEntry({
          name: areaName,

          parentCity: parentCity.slug,

          state: parentCity.state,
        });


      /*
       * Never overwrite an existing manually
       * created city/location.
       *
       * Example:
       *
       * If "pimpri" already exists manually,
       * automatic generation will skip it.
       */

      if (cities[location.slug]) {
        return;
      }


      cities[location.slug] = location;

    });

  }
);


/* =========================================================
   OPTIONAL DEVELOPMENT INFORMATION
========================================================= */

if (
  typeof process !== "undefined" &&
  process.env?.NODE_ENV === "development"
) {

  const generatedLocations =
    Object.values(cities).filter(
      (city) =>
        city.isGeneratedLocation === true
    );


  console.log(
    `[cities.js] Generated ${generatedLocations.length} location pages.`
  );

}


/* =========================================================
   EXPORT
========================================================= */

export default cities;